import React from 'react';
import ILampTrainingDashboard from './ILampTrainingDashboard';

function App() {
  return <ILampTrainingDashboard />;
}

export default App;